import { CLEAR_ZENDESK_RETURN_TO_URL } from 'actions';

export default function setZendeskReturnToUrl() {
  return {
    type: CLEAR_ZENDESK_RETURN_TO_URL,
  };
}
